import $$ from './cms/axios-cms.service';
import { GLOBAL_CATALOGS, I18_NEXT_LNG } from '../store/types';
import { getHttp, postHttp } from './cms/http-cms.service';
import { LocalStorage } from '../utils/storage';

// 無需登錄獲取TOKE
export const signCms = ({ i18n = LocalStorage.get(I18_NEXT_LNG)  }) => postHttp(`/cms/app-api/login-sign/TW`);


export const loginCms = (params) => postHttp(`/cms/app-api/login/${params?.siteId}`, params);


/*
* CMS BY站点栏目树信息查询
* siteId i18n 栏目查询内容列表
* */
export const queryCatalogs = ({ siteId, i18n }) => $$.get(`/cms/app-api/catalogs/${siteId}/${i18n}`);

// CMS BY栏目查询子栏目查询
export const queryTreeCatalogs = ({ siteId, i18n = LocalStorage.get(I18_NEXT_LNG), contentCode = GLOBAL_CATALOGS.Navigations, level = 0 }) => getHttp(`/cms/app-api/catalogs/${siteId}/${contentCode}/${i18n}`, { level });


/*
* CMS BY栏目查询内容列表
* siteId contentCode i18n 栏目查询内容列表
* */
export const queryCatalogsContents = ({ siteId, contentCode, i18n = LocalStorage.get(I18_NEXT_LNG), hasDetails, ruleTag }) => getHttp(`/cms/app-api/catalogs/content/${siteId}/${contentCode}/${i18n}`, { hasDetails, ruleTag });


/*
* CMS BY栏目查询内容分頁列表
* siteId contentCode i18n 栏目查询内容分頁列表
* */
export const queryCatalogsContentList = ({ siteId, contentCode, i18n = LocalStorage.get(I18_NEXT_LNG), hasDetails, ruleTag, title, pageNum, pageSize }) => getHttp(`/cms/app-api/catalogs/content/page/${siteId}/${contentCode}/${i18n}`, { title, hasDetails, ruleTag, pageNum, pageSize });


/*
* CMS BY 查詢當前欄目下所有子欄目的内容分頁列表
*  title keyWords tags catalogs ruleTag siteId i18n pageNum pageSize
* */
export const queryAllCatalogsContents = ({ siteId, catalogs, i18n = LocalStorage.get(I18_NEXT_LNG), hasDetails, ruleTag, title, pageNum, pageSize }) => getHttp(`/cms/app-api/catalogs/content/page/${siteId}/${i18n}`, { catalogs, title, hasDetails, ruleTag, pageNum, pageSize });


/*
* CMS BY栏目查询内容详情
*  catalogId contentType contentId i18n
* */
export const queryCatalogsContentDetail = ({ catalogId, contentType, contentId, i18n = LocalStorage.get(I18_NEXT_LNG) }) => getHttp(`/cms/app-api/content/init/${catalogId}/${contentType}/${contentId}/${i18n}`);

/*
* CMS 查詢欄目点击歷史記錄
* CMS BY站点查询点击栏目最多的N个
* siteId:必填 number i18n
* */
export const queryCatalogsHistory = ({ siteId, i18n = LocalStorage.get(I18_NEXT_LNG) }) => getHttp(`/cms/app-api/catalogs/hit/${siteId}/${i18n}`);


